<div id="{{appName}}_alert_popup" *ngIf="!message.type">
    <div mat-dialog-content class="alert-modal-content">
        <div class="row col-md-12">{{message}}</div>
    </div>

    <div mat-dialog-actions class="alert-modal-footer">
        <span>
            <button mat-button class="btn btn-default btn-yes" [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
        </span>
    </div>
</div>